import React from 'react'
import PropTypes from 'prop-types'

class ControlsGroup extends React.Component {
  wrapInControlDiv = (item, index) => {
    const {modifier} = this.props
    if (modifier === 'wrapper') {
      return {
        ...item,
        key: index.toString(),
      }
    }
    return (
      <div key={index.toString()} className="controlsgroup-control">
        {item}
      </div>
    )
  }

  render() {
    const {modifier, children} = this.props
    const className = `controlsgroup${modifier ? ` controlsgroup--${modifier}` : ''}`
    if (!children || (children.length && children.filter(item => !!item).length === 0)) {
      return null
    }
    return (
      <div className={className}>
        {children && children.length
          ? children.filter(item => !!item).map(this.wrapInControlDiv)
          : this.wrapInControlDiv(children, 0)}
      </div>
    )
  }
}

ControlsGroup.propTypes = {
  children: PropTypes.any,
  modifier: PropTypes.string,
}

export default ControlsGroup
